import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import qs from "querystring";

import Slot from "@/v1/components/atoms/Slot";

import "./errorPage.scss";

const ErrorPage = ({ code }) => {
  const [errorCode, setErrorCode] = useState(false);

  useEffect(() => {
    const search = `${window.location.search}`.substr(1); // NOSONAR
    const codeParam = qs.parse(search);
    setErrorCode(codeParam.code || code);
  }, [code]);

  return (
    <section className="error-page">
      {errorCode && (
        <>
          <div className="error-page__slot-container">
            <Slot arrangedResults={errorCode.split("")} />
          </div>
          <div className="error-page__container">
            <h1 className="error-page__title">{errorCode}</h1>
            <h3 className="error-page__sub-title">
              <FormattedMessage id={`error-status.${errorCode}`} />
            </h3>
            <p className="error-page__content">
              <FormattedMessage id="error-status.label" />
            </p>
            <Link to="/">
              <FormattedMessage id="error-status.go-to-website" />
            </Link>
          </div>
        </>
      )}
    </section>
  );
};

ErrorPage.propTypes = {
  code: PropTypes.string,
};

ErrorPage.defaultProps = {
  code: "404",
};

export default ErrorPage;
